import React, { useState } from "react";
import TemplateTable from "./TemplateTable";
import TemplateOrdering from "./TemplateOrdering";
import styled, { css } from "react-emotion";
import {
  ApplicationColorForm,
  ApplicationLayoutForm,
  SaveProgress,
  AppView,
} from "components";
// import AppView from "components/AppView";
import { withRedux, displayError } from "helpers";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "appStyles";
import Modal from "@material-ui/core/Modal";
import AlertModal from "../../Tools/AlertModal";
import PublishIcon from "@material-ui/icons/Publish";
import CreateIcon from "@material-ui/icons/Create";
import CloseIcon from "@material-ui/icons/Close";
import { getStripeExpressDashboardLink } from "apis";
import Tooltip from "@material-ui/core/Tooltip";
import HelpTwoToneIcon from "@material-ui/icons/HelpTwoTone";
import { makeStyles } from "@material-ui/core/styles";
import WebIcon from "../../../pages/Web/WebIcon";

export const tableRowClickable = css`
  &:hover {
    background-color: rgba(137, 210, 211, 0.3);
    cursor: pointer;
  }
`;
export const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-bottom: 35px;
`;
export const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const mdcButton = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

const inlineBlock = css`
  display: inline-block;
`;

const bodyStyle = css`
  width: 100%;
`;
const toastStyle = css`
  border: 2.5px solid rgb(137, 210, 211);
`;

const publishText = `If this button is illuminated, the changes you've made to your app are not available to your customers. Only you can view them as an admin. To publish changes to your customers, click here.`;

const saveText = `If this button is illuminated, you have made changes which haven't been saved yet. After clicking save, be sure to exit and reenter your mobile app "as admin" to view the changes made.`;

const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 300,
    fontSize: "14px",
  },
}));

function EditApp(props) {
  const [confirmPublish, setConfirmPublish] = useState(false);
  const [requestSuccess, setrequestSuccess] = useState(false);
  const [showTemplateOrdering, setshowTemplateOrdering] = useState(false);
  const { activeApp, business } = props;
  const classes = useStyles();

  const Msg = (props) => {
    const { message } = props;
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ marginRight: "10px" }}>
            {" "}
            <WebIcon
              iconName={"checkMark"}
              useColor={true}
              size={"16px"}
              hover={false}
              className={inlineBlock}
              customColor={"#4caf50"}
            />
          </div>
          <p>{message}</p>
        </div>
      </div>
    );
  };

  const notify = (action, name) => {
    switch (action) {
      case "copy":
        toast(Msg({ message: "Copied download link" }), {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        break;
      case "unPublishedTemplate":
        toast(Msg({ message: name + " has been unpublished." }), {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        break;
      case "publishedTemplate":
        toast(Msg({ message: name + " has been published." }), {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        break;
      case "published":
        toast(
          Msg({ message: "🤩🤩 " + activeApp.name + " has been published!" }),
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          }
        );
        break;
      default:
        break;
    }
  };

  const publishApp = () => {
    const updatedApp = {
      ...activeApp,
    };

    if (confirmPublish) {
      props.actions.putBusinessApp(business, updatedApp, true).then(() => {
        notify("published");
      });
      setConfirmPublish(false);
    } else {
      setConfirmPublish(false);
    }
  };

  const updateApp = (field) => (value) => {
    props.actions.updateApplication(field, value);
  };

  const updateNav = (field) => (value) => {
    props.actions.updateNavBar(field, value);
  };

  const updateNavType = (value) => {
    props.actions.updateNavBar("type", value);
  };

  const toggleModal = () => {
    setConfirmPublish(!confirmPublish);
  };
  const renderButtons = [
    <a
      key="cancelButton"
      style={{
        backgroundColor: "white",
        cursor: "pointer",
        color: "#1976d2",
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
        fontSize: "0.9375rem",
      }}
      onClick={toggleModal}
    >
      Cancel
    </a>,
    <a
      onClick={publishApp}
      key="discardButton"
      style={{
        cursor: "pointer",
        backgroundColor: "white",
        color: "#89d2d3",
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
        paddingLeft: "10px",
        fontSize: "0.9375rem",
      }}
    >
      Publish
    </a>,
  ];
  const renderConfirmPublishModal = () => {
    if (!confirmPublish) return null;

    return (
      <AlertModal
        title="Confirm Publish Application"
        buttons={renderButtons}
        render={confirmPublish}
      >
        <P>
          Are you sure you want to publish your application? This can't be
          undone!
        </P>
      </AlertModal>
    );
  };

  const updateLogoImage = (url) => {
    // console.log("updating logo pic " + url);
    let updatedApp = props.activeApp;
    // console.log(updatedApp);
    if (url) {
      if (updatedApp.logo === null) {
        // console.log("found null logo");
        props.actions.updateApplicationInfo("logo", url);
      } else {
        // console.log("a logo exists");
        props.actions.updateApplicationInfo("logo", url);
      }
    } else {
      props.actions.updateApplicationInfo("logo", "");
    }
  };

  const submitRequestToPublish = async () => {
    const { id } = props.platformInfo.status.user;
    const {
      activeApp: { id: appId },
    } = props;
    props.history.push(`/checkout?appId=${appId}`);
  };

  const renderPublishButton = () => {
    const { publishable, isVerified } = props.activeApp;

    if (publishable && isVerified) {
      return (
        <Button
          cursor={publishable ? "pointer" : "default"}
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: "0px ",
            textAlign: "center",
            backgroundColor: publishable ? "#89d2d3" : "#adadad",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
          className={mdcButton}
          onClick={toggleModal}
        >
          <PublishIcon style={{ marginRight: "5px" }}></PublishIcon>
          Publish Application
        </Button>
      );
    } else if ((publishable && !isVerified) || (!publishable && !isVerified)) {
      return (
        <Button
          cursor="pointer"
          onClick={submitRequestToPublish}
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: "0px",
            textAlign: "center",
            backgroundColor: "#89d2d3",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
          className={mdcButton}
        >
          <CreateIcon
            style={{ marginRight: "5px" }}
            className={"reqToPublish"}
          ></CreateIcon>
          Request to Publish
        </Button>
      );
    } else {
      return (
        <Button
          cursor="pointer"
          onClick={toggleModal}
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: "0px",
            textAlign: "center",
            backgroundColor: publishable ? "#89d2d3" : "#adadad",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
          className={mdcButton}
          disabled={!publishable}
        >
          <CreateIcon style={{ marginRight: "5px" }}></CreateIcon>
          Publish Updates
        </Button>
      );
    }
  };

  const renderRequestSuccessMessage = () => {
    if (!requestSuccess) return null;
    return (
      <Modal hidden={true} padding="1em">
        <p>We have received your request to publish your application!</p>
        <br />
        <p>We will contact you via email within 24 hours.</p>
        <br />
        <Button onClick={() => setrequestSuccess(false)}>Ok</Button>
      </Modal>
    );
  };

  const renderTemplateOrdering = () => {
    if (!showTemplateOrdering) return null;
    const { activeApp } = props;
    const {
      view: {
        navigation: { components },
      },
    } = activeApp;

    return (
      <Modal
        open={showTemplateOrdering}
        onClose={() => setshowTemplateOrdering(false)}
        style={{
          margin: "auto",
          width: "35%",
          top: "10%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            height: "550px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setshowTemplateOrdering(false)}
          >
            <CloseIcon></CloseIcon>
          </span>
          <TemplateOrdering navigation={components} />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <SaveProgress
              height="3%"
              callback={() => setshowTemplateOrdering(false)}
            />
          </div>
        </div>
      </Modal>
    );
  };

  const getStripeUrl = async (id) => {
    try {
      const result = await getStripeExpressDashboardLink(id);
      return result.text();
    } catch (e) {
      console.error(e);
      alert("Error: Failed to retrieve stripe url");
    }
  };

  const renderStripePrompt = () => {
    const { activeApp } = props;
    const { id } = activeApp;
    let detailsSubmitted = null;
    let requiresMoreInfo = null;
    if (activeApp.stripeExpressAccountInfo) {
      const {
        stripeExpressAccountInfo: {
          stripeExpressDetailsSubmitted,
          stripeExpressRequiresMoreInfo,
        },
      } = activeApp;
      detailsSubmitted = stripeExpressDetailsSubmitted;
      requiresMoreInfo = stripeExpressRequiresMoreInfo;
    }

    if (detailsSubmitted === null && requiresMoreInfo === null) {
      return null;
    }

    if (detailsSubmitted && !requiresMoreInfo) {
      return null;
    }

    return (
      <div
        style={{
          padding: "10px 20px",
          border: "1px solid rgb(137, 210, 211)",
          borderRadius: "5px",
          margin: "10px 20px 0px 0px",
          background: "#e6f3f3",
        }}
      >
        <p style={{ color: "black", fontWeight: "bold" }}>
          {detailsSubmitted &&
            requiresMoreInfo &&
            "Stripe Needs to Verify More Information"}
          {!detailsSubmitted && requiresMoreInfo && "Setup Payout Information"}
        </p>

        {detailsSubmitted && requiresMoreInfo ? (
          <p
            style={{
              fontSize: "12px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            Your app won’t be able to process payments and you won’t receive
            payouts until this is complete. Sometimes Stripe requires extra
            verification to finalize your account. Usually they will require 2-3
            additional steps so bear with us. After completing the required
            steps, please return to Mobile360 and refresh the screen to see if
            more steps are required.
          </p>
        ) : (
          <p
            style={{
              fontSize: "12px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            Mobile360 has integrated with Stripe for secure credit card
            processing. Just like all credit card processors, Stripe charges a
            standard credit card processing fee which can be found{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/pricing"}
            >
              here
            </a>
            . To accept payments via credit card and to receive daily payouts to
            your bank account or debit card, you must complete your Stripe
            setup. The first payout takes 7 - 14 days after your first purchase
            as specified{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/docs/payouts"}
            >
              here
            </a>
            . By doing so, you agree to their fees,{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/legal"}
            >
              Services Agreement
            </a>{" "}
            and{" "}
            <a
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "black",
              }}
              href={"https://stripe.com/connect-account/legal"}
            >
              Stripe Connected Account Agreement
            </a>
            . Please remember, Mobile360 simply serves as the intermediary
            between you and your customers, but you are responsible for all
            transactions that flow through your app, including refunds and
            refutations.
          </p>
        )}

        <Button
          style={{
            display: "inline-flex",
            alignItems: "center",
            margin: "5px 0px 10px 0px",
            textAlign: "center",
            height: "30px",
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          }}
          onClick={() =>
            getStripeUrl(id).then((url) => {
              Object.assign(document.createElement("a"), {
                target: "_blank",
                href: url,
              }).click();
            })
          }
        >
          {" "}
          <a
            style={{
              fontSize: "12px",
              color: "white",
              fontWeight: "bold",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            {detailsSubmitted && requiresMoreInfo && "Continue to Stripe"}
            {!detailsSubmitted &&
              requiresMoreInfo &&
              "Setup Payout Information Now"}
          </a>
        </Button>
      </div>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        overflowY: "scroll",
        height: "90vh",
        marginLeft: "10px",
      }}
    >
      <div>
        {/* style={{ overflowY: "auto", overflowX: "hidden", height: "100vh" }} */}
        {renderStripePrompt()}

        <div
          style={{
            boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
            minHeight: "580px",
            padding: "20px",
            marginTop: "1em",
            width: "735px",
            // maxWidth: "1118px",
          }}
        >
          {renderRequestSuccessMessage()}
          {renderConfirmPublishModal()}
          {renderTemplateOrdering()}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <H1
              style={{
                display: "inline-block",
                letterSpacing: "2px",
                fontSize: "24px",
              }}
            >
              Application Settings
            </H1>
            <div style={{ display: "flex", alignItems: "center" }}>
              {renderPublishButton()}
              <Tooltip
                title={publishText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginLeft: "15px" }}
                />
              </Tooltip>
            </div>
          </div>

          {/* <hr style={{ marginTop: "20px" }}></hr> */}
          <div
            style={{
              height: "80px",
              width: "100%",
            }}
          >
            <ApplicationColorForm
              application={activeApp}
              updateNav={updateNav}
              update={updateApp}
            />

            <ApplicationLayoutForm
              application={activeApp}
              updateNavType={updateNavType}
              updateLogoImage={updateLogoImage}
              updateLandingPagePath={updateApp}
              notify={notify}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <SaveProgress height="auto" />
              <Tooltip
                title={saveText}
                classes={{ tooltip: classes.customWidth }}
              >
                <HelpTwoToneIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <div> {/* <AppView scale="0.8" top="2em" /> */}</div>
      </div>
      <TemplateTable
        showTemplateOrdering={() => setshowTemplateOrdering(true)}
        history={props.history}
        notify={notify}
      />
      <div>
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          transition={Slide}
          closeButton={false}
          bodyClassName={bodyStyle}
          toastClassName={toastStyle}
        />
      </div>
    </div>
  );
}

export default withRedux(EditApp);
